/** Build absolute canonical URL with a single slash between base and path */
export function buildCanonicalUrl(path = '') {
  const base = (process.env.VUE_APP_URL || '').replace(/\/?$/, '/');
  const normalized = String(path).replace(/^\//, '');
  return normalized ? `${base}${normalized}` : base.slice(0, -1) || base;
}

export const DEFAULT_JOBS_LIST_KEYWORDS = 'Jobs,Entry Level jobs, freshers opening, IT, Software, Core Technical ,Government , Defence , Research , Internship, BPO, MBA, Teaching, Pharma, StartUp, Diploma , BBM, BCA , BSc, Scholarships, Dream, Walkin , 1 to 3 Yr Exp jobs,jobs in Bangalore, pune, mumbai,Kolkata, Chennai, Delhi,  B.tech freshers job, freshers IT jobs, Btech,MBA,mechanical, electrical, engineering jobs';

export const DEFAULT_JOBS_LIST_DESCRIPTION = 'Entry Level Jobs Search.Latest Jobs for Freshers In India. Government, IT software,bank , sales, MNC , work from home job vacancies';
